import { gql } from '@apollo/client';

export interface PendingRouteItem {
    dspTaskId: number | null;
    driverTaskId: number | null;
    routeStatus: number | null;
    areaId: number | null;
    areaName: string | null;
    dspId: number | null;
    dspName: string | null;
    split: boolean | null;
    assignType: number | null;
    assignTypeDetail: string[] | null;
    driverId: number | null;
    driverName: string | null;
    newParcelCount: number | null;
    plannedParcelCount: number | null;
    totalParcelCount: number | null;
    parcelNumberStart: number | null;
    parcelNumberEnd: number | null;
    childTaskList: PendingRouteItem[];
}

export interface GetPendingRoutesResponse {
    getPendingRoutes: PendingRouteItem[];
}

export interface GetPendingRoutesVariables {
    request: {
        warehouseId: number;
        dspId?: number | null;
    };
}

export const GET_PENDING_ROUTES_FOR_DSP = gql`
    query GetPendingRoutesForDsp($request: GetPendingRoutesRequestInput!) {
        getPendingRoutesForDsp(request: $request) {
            dspTaskId
            driverTaskId
            routeStatus
            areaId
            areaName
            dspId
            dspName
            split
            assignType
            assignTypeDetail
            driverId
            driverName
            newParcelCount
            plannedParcelCount
            totalParcelCount
            parcelNumberStart
            parcelNumberEnd
            childTaskList {
                dspTaskId
                driverTaskId
                routeStatus
                areaId
                areaName
                dspId
                dspName
                split
                assignType
                assignTypeDetail
                driverId
                driverName
                newParcelCount
                plannedParcelCount
                totalParcelCount
                parcelNumberStart
                parcelNumberEnd
            }
        }
    }
`;

export const GET_PENDING_ROUTES = gql`
    query GetPendingRoutes($request: GetPendingRoutesRequestInput!) {
        getPendingRoutes(request: $request) {
            dspTaskId
            driverTaskId
            routeStatus
            areaId
            areaName
            dspId
            dspName
            split
            assignType
            assignTypeDetail
            driverId
            driverName
            newParcelCount
            plannedParcelCount
            totalParcelCount
            parcelNumberStart
            parcelNumberEnd
            childTaskList {
                dspTaskId
                driverTaskId
                routeStatus
                areaId
                areaName
                dspId
                dspName
                split
                assignType
                assignTypeDetail
                driverId
                driverName
                newParcelCount
                plannedParcelCount
                totalParcelCount
                parcelNumberStart
                parcelNumberEnd
            }
        }
    }
`;
